import React, { useState } from 'react';
import { storage, db } from './firebase';
import { ref, uploadBytes, getDownloadURL } from 'firebase/storage';
import { collection, addDoc, Timestamp } from 'firebase/firestore';
import { useNavigate } from 'react-router-dom';

const ParentUpload = () => {
  const [images, setImages] = useState([]);
  const [previewUrls, setPreviewUrls] = useState([]);
  const [uploading, setUploading] = useState(false);
  const navigate = useNavigate();

  const handleImageChange = (e) => {
    const files = Array.from(e.target.files);
    setImages(files);
    setPreviewUrls(files.map(file => URL.createObjectURL(file)));
  };

  const removeImage = (indexToRemove) => {
    setImages(images.filter((_, i) => i !== indexToRemove));
    setPreviewUrls(previewUrls.filter((_, i) => i !== indexToRemove));
  };

  const handleUpload = async () => {
    if (images.length === 0) return alert("Please select at least one photo.");
    setUploading(true);

    try {
      for (const image of images) {
        const imageRef = ref(storage, `gallery/${Date.now()}-${image.name}`);
        await uploadBytes(imageRef, image);
        const imageUrl = await getDownloadURL(imageRef);

        await addDoc(collection(db, 'gallery'), {
          imageUrl,
          createdAt: Timestamp.now(),
        });
      }

      alert("All photos uploaded successfully!");
      setImages([]);
      setPreviewUrls([]);
    } catch (err) {
      console.error(err);
      alert("Upload failed. Try again.");
    }

    setUploading(false);
  };

  return (
    <div style={{ maxWidth: '700px', margin: '0 auto' }}>
      <h2 style={{ color: '#B4975A' }}>Upload Team Photos</h2>

      <div style={{ display: 'flex', flexWrap: 'wrap', gap: '10px', marginBottom: '1rem' }}>
        {previewUrls.map((url, index) => (
          <div key={index} style={{ position: 'relative' }}>
            <img
              src={url}
              alt={`Preview ${index}`}
              style={{ width: '120px', borderRadius: '8px' }}
            />
            <button
              onClick={() => removeImage(index)}
              style={{
                position: 'absolute',
                top: 0,
                right: 0,
                backgroundColor: 'rgba(0,0,0,0.6)',
                color: 'white',
                border: 'none',
                borderRadius: '0 0 0 6px',
                cursor: 'pointer',
                fontSize: '12px',
                padding: '4px 6px',
              }}
            >
              ✕
            </button>
          </div>
        ))}
      </div>

      <input
        type="file"
        accept="image/*"
        id="photoUpload"
        style={{ display: 'none' }}
        multiple
        onChange={handleImageChange}
      />

      <label
        htmlFor="photoUpload"
        style={{
          display: 'inline-block',
          backgroundColor: '#00a7a9',
          color: 'black',
          fontWeight: 'bold',
          padding: '10px 20px',
          border: 'none',
          borderRadius: '6px',
          cursor: 'pointer',
          marginBottom: '10px',
          width: '100%',
          textAlign: 'center',
        }}
      >
        Choose Photos
      </label>

      <button
        onClick={handleUpload}
        disabled={uploading}
        style={{
          marginTop: '10px',
          backgroundColor: '#00a7a9',
          color: 'black',
          fontWeight: 'bold',
          padding: '10px 20px',
          border: 'none',
          borderRadius: '6px',
          cursor: 'pointer',
          width: '100%',
        }}
      >
        {uploading ? 'Uploading...' : 'Upload All Photos'}
      </button>

      {/* Go to Gallery Button */}
      <button
        onClick={() => navigate('/gallery')}
        style={{
          marginTop: '20px',
          backgroundColor: '#B4975A',
          color: 'white',
          fontWeight: 'bold',
          padding: '10px 20px',
          border: 'none',
          borderRadius: '6px',
          cursor: 'pointer',
          width: '100%',
        }}
      >
        View Team Gallery 
      </button>
    </div>
  );
};

export default ParentUpload;
